import { render, staticRenderFns } from "./_base-selector.vue?vue&type=template&id=4f59f6d0"
import script from "./_base-selector.vue?vue&type=script&lang=js"
export * from "./_base-selector.vue?vue&type=script&lang=js"
import style0 from "./_base-selector.vue?vue&type=style&index=0&id=4f59f6d0&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports